import { useParams } from "react-router-dom";

import ApiKeysTable from "routes/admin/components/api_keys_table/ApiKeysTableV3";
import GroupsTable from "routes/admin/components/groups_table/GroupsTableV3";
import RolesTable from "routes/admin/components/roles_table/RolesTableV3";
import UsersTable from "routes/admin/components/UsersTable/UsersTableV3";

import CallDispositionsTable from "routes/call_dispositions/components/call_dispositions_table/CallDispositionsTableV3";
import TwilioPhoneNumbersTable from "routes/twilio_phone_numbers/TwilioPhoneNumbersTableV3";
import VoicemailsTable from "routes/voicemail/components/voicemail_table/VoicemailTableV3";
import CampaignsStatusPresetsTable from "routes/campaign_status_presets/CampaignStatusPresetsTableV3";
import RegionsTableV3 from "routes/regions/RegionsTableV3";
import RevenueOpportunityStatusesTable from "components/RevenueOpportunityStatusTable/RevenueOpportunityStatusTableV3";
import AccountsTable from "routes/constant_contact/components/accounts_table/AccountsTableV3";
import CampaignActivityTable from "routes/constant_contact/components/campaign_activity_table/CampaignActivityTableV3";
import CustomFieldConfigTable from "routes/custom_field/components/custom_field_config_table/CustomFieldConfigTableV3";
import CustomFieldGroupsTableV3 from "routes/custom_field_group/CustomFieldGroupsTableV3";
import EmailFooterTableV3 from "routes/email/EmailFooterTableV3";
import EmailTemplateTableV3 from "routes/email/EmailTemplateTableV3";
import EmailUrlsTableV3 from "routes/email_urls/components/email_urls_table/EmailUrlsTableV3";
import EmailSignatureTableV3 from "routes/email/EmailSignatureTableV3";
import EmailAttachmentTableV3 from "routes/email/EmailAttachmentTableV3";
import CustomEmailDomainsTable from "routes/custom_email_domains/CustomEmailDomainsTableV3";
import MxDomainsTableV3 from "routes/mx_domains/MxDomainsTableV3";
import EmailExemptionsTable from "routes/email/components/email_exemptions_table/EmailExemptionsTableV3";
import PointsOfContactTable from "routes/points_of_contact/points_of_contact_table/PointsOfContactTableV3";
import ProductsTable from "routes/product/products_table/ProductsTableV3";
import ProductLinesTable from "routes/product_line/product_lines_table/ProductLinesTableV3";
import RecipientsTable from "routes/recipients/recipients_table/RecipientsTableV3";
import TagCategoryTable from "routes/tag_category/TagCategoryTableV3";
import SourceStatusesTable from "components/source_statuses_table/SourceStatusesTableV3";
import CaseDomainsTable from "components/case_domains_table/CaseDomainsTableV3";
import InvestigationStatusesTableV3 from "routes/investigation_status/InvestigationStatusesTableV3";
import GlobalSettings from "./global/GlobalSettings";
import CampaignsStatusesTable from "routes/campaign_status/components/campaign_statuses_table/CampaignStatusesTableV3";
import RevenueOpportunityRecipientPresetsTableV3 from "routes/revenue_opportunity_recipient_presets/RevenueOpportunityRecipientPresetsTableV3";
import RevenueOpportunityStatusPresetsTableV3 from "routes/revenue_opportunity_status_presets/RevenueOpportunityStatusPresetsTableV3";
import MachineApprovalStatusTableV3 from "routes/machine_approval_statuses/MachineApprovalStatusTableV3";
import MetaLeadsEventsTableV3 from "routes/meta_leads_events/MetaLeadsEventsTableV3";
import NoteTemplateTableV3 from "routes/note_template/NoteTemplateTableV3";

const components = {
  global_settings: GlobalSettings,
  users: UsersTable,
  roles: RolesTable,
  api_keys: ApiKeysTable,
  groups: GroupsTable,
  call_dispositions: CallDispositionsTable,
  phone_numbers: TwilioPhoneNumbersTable,
  voicemails: VoicemailsTable,
  campaign_status_presets: CampaignsStatusPresetsTable,
  campaign_statuses: CampaignsStatusesTable,
  regions: RegionsTableV3,
  revenue_opportunity_statuses: RevenueOpportunityStatusesTable,
  revenue_opportunity_status_presets: RevenueOpportunityStatusPresetsTableV3,
  revenue_opportunity_recipient_presets:
    RevenueOpportunityRecipientPresetsTableV3,
  constant_contact_accounts: AccountsTable,
  constant_contact_campaigns: CampaignActivityTable,
  custom_field_configs: CustomFieldConfigTable,
  email_footers: EmailFooterTableV3,
  email_templates: EmailTemplateTableV3,
  email_urls: EmailUrlsTableV3,
  email_signatures: EmailSignatureTableV3,
  email_attachments: EmailAttachmentTableV3,
  email_exemptions: EmailExemptionsTable,
  points_of_contact: PointsOfContactTable,
  products: ProductsTable,
  product_lines: ProductLinesTable,
  custom_email_domains: CustomEmailDomainsTable,
  mx_domains: MxDomainsTableV3,
  recipients: RecipientsTable,
  tag_categories: TagCategoryTable,
  source_statuses: SourceStatusesTable,
  case_domains: CaseDomainsTable,
  custom_field_groups: CustomFieldGroupsTableV3,
  investigation_statuses: InvestigationStatusesTableV3,
  machine_approval_statuses: MachineApprovalStatusTableV3,
  meta_leads_events: MetaLeadsEventsTableV3,
  note_templates: NoteTemplateTableV3,
};

const DefaultView = () => (
  <div>
    <p>
      From this page you can customize Pleteo to match how your business
      operates.
    </p>
    <p>Please select an option from the menu on the left to continue.</p>
  </div>
);

const Settings = () => {
  const { item } = useParams();

  const Component = item ? components[item] : null;

  return Component ? <Component /> : <DefaultView />;
};

export default Settings;
